// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__11tGs","icon":"SortAdornment_icon__2WkIh","up":"SortAdornment_up__mOcBK","down":"SortAdornment_down__GE4s2","active":"SortAdornment_active__256QP"};